import React, { useContext, useState, useEffect } from "react";
import Main from "../layout/Main";
import schoolApi from "../../api/schoolApi";
import { Button, Col, Form, Table, Row } from "react-bootstrap";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useOutletContext } from "react-router-dom";

const localizer = momentLocalizer(moment);

const ShowEvent = () => {
  const [selectedStudent, setStudent] = useOutletContext();
  const [selectedStudentId, setStudentId] = useState([]);
  const [selectedSessionId, setSessionId] = useState({});
  const [events, setEvents] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        let data = await schoolApi.fetchEvents();
        console.log("1111adata=>", data);
        if (data?.success === true) {
          setEvents(data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setEvents([]);
      }
    }
    fetchData();
  }, []);

  const handleStudentHome = async (selectedStudent) => {
    console.log("Student Id9090 =>", selectedStudent);
    setStudentId(selectedStudent);
  };

  const handleStudentSessionIdHome = async (selectedSessionId) => {
    console.log("Session Id =>", selectedSessionId);
    setSessionId(selectedSessionId);
  };

  const eventPropGetter = (event) => {
    const eventProps = {};
    if (event && event.title) {
      const color = event.colorcode;
      eventProps.style = {
        backgroundColor: color,
      };
    }
    return eventProps;
  };
  return (
    <>
      <div className="mx-4 mt-2">
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start_date"
          endAccessor="end_date_model"
          // onSelectEvent={onSelectEvent}
          style={{ height: 500 }}
          eventPropGetter={eventPropGetter}
          views={["month", "agenda"]}
        />
      </div>
    </>
  );
};

export default ShowEvent;
